module.exports = __webpack_public_path__ + "static/img/02.77a6c6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/how_it_works/02.png
// module id = 6Lcw
// module chunks = 1